
import Vue from 'vue'
import staticBlockMixin from '~/mixins/staticBlockMixin'

export default Vue.extend({
  name: 'CreditDepositCard',
  mixins: [staticBlockMixin],
  inject: [
    'globalFormProvider',
    'setGlobalFormProviderProperties'
  ],
  props: {
    productList: {
      type: Array,
      default: () => []
    }

  },
  data () {
    return {
      selectedCard: ''
    }
  },
  computed: {
    formTypeId () {
      return !this.mainFields['button-link-1']?.value
        ? this.mainFields['button-title-1']?.value?.includes('вклад')
          ? this.$config?.app?.forms?.ids?.DEPOSIT
          : this.$config?.app?.forms?.ids?.CREDIT
        : this.mainFields['button-link-1']?.value
    }
  },
  watch: {
    '$route.query.form' (val) {
      if (!val) { this.selectedCard = '' }
    }
  },
  methods: {
    setFormSettings () {
      this.setGlobalFormProviderProperties({
        typeId: this.formTypeId,
        typeOfCard: this.selectedCard,
        isLong: this.$attrs?.['is-long'] || this.blockParams?.isLong,
        productList: this.productList
      })
    },
    openModal () {
      this.selectedCard = this.mainFields?.title?.value
      this.setFormSettings()
      this.$router.push({ query: { ...this.$route.query, form: this.formTypeId } })
    },
    // Генерация ссылки на свг файл
    svgPath () {
      return `${this.$config.API_URL}/image-minifier/v1/${this.mainFields?.image?.value}.svg`
    }
  }
})
